import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminTopBar from '../../components/AdminTopBar';
import DashboardModuleTabs from '../../components/admin/dashboard/DashboardModuleTabs';

// Admin Yardım sayfası — jargonsuz rehber. .agent/docs/ADMIN_PANEL_KULLANIM_KILAVUZU.md ile aynı içerik.
const TABS = [
  { to: '/admin', name: 'Karar Motoru', q: '"Bugün nelere bakmalıyım? Bir şey ters mi?"', when: 'İlk durak; genel durumu görmek için' },
  { to: '/admin/segment-analysis', name: 'Segment Analizi', q: '"Şu tip kullanıcılar kimler ve nasıl davranıyor?"', when: 'Elinde somut bir soru olunca' },
  { to: '/admin/product-analytics', name: 'Ürün Analizi', q: '"Hangi tarif/ürün nasıl gidiyor?"', when: 'Ürün tarafını gözden geçirirken' },
  { to: '/admin/behavior-templates', name: 'Mesaj Şablonları', q: '"Kullanıcıya ne mesaj gitsin, tutuyor mu?"', when: 'Bildirim metni yazıp yayınlarken' },
  { to: '/admin/behavior-insights', name: 'Davranış İçgörüleri', q: '"Sistem benim için ne çıkardı?"', when: 'Hazır cevap istediğinde' },
  { to: '/admin/behavior-metrics', name: 'Davranış Ölçümleri', q: '"Her şey yolunda mı? (nabız)"', when: '"Bir şey bozuldu mu?" kontrolü' }
];

const GOTO = [
  { need: 'Bir ürünün fiyatını/özelliğini düzeltmek', to: '/admin/veri-havuzu', go: 'Veri Havuzu' },
  { need: 'Genel duruma tek bakış', to: '/admin', go: 'Karar Motoru' },
  { need: '"Şu grup ne yapıyor?" diye sormak', to: '/admin/segment-analysis', go: 'Segment Analizi' },
  { need: 'Hazır çıkarım + önerilen aksiyon', to: '/admin/behavior-insights', go: 'Davranış İçgörüleri' },
  { need: 'Kullanıcıya mesaj yazıp yayınlamak', to: '/admin/behavior-templates', go: 'Mesaj Şablonları' },
  { need: 'Tarif/ürün performansı', to: '/admin/product-analytics', go: 'Ürün Analizi' },
  { need: '"Sistem sağlıklı mı?"', to: '/admin/behavior-metrics', go: 'Davranış Ölçümleri' }
];

function Card({ children, className = '' }) {
  return (
    <section className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-[#101922] ${className}`}>
      {children}
    </section>
  );
}

function H2({ children }) {
  return <h2 className="text-lg font-black text-slate-900 dark:text-white">{children}</h2>;
}

export default function AdminHelpPage() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0d141c]">
      <AdminSidebar
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={() => setMobileSidebarOpen(false)}
      />
      <main className="flex-1 md:ml-[var(--admin-sidebar-width,18rem)] flex flex-col min-h-screen transition-[margin] duration-300">
        <AdminTopBar title="Yardım" onToggleMobile={() => setMobileSidebarOpen(true)} />
        <div className="flex-1 space-y-6 p-4 sm:p-8">
          <DashboardModuleTabs />
          <div className="mx-auto w-full max-w-4xl space-y-6">

          <header>
            <h1 className="text-2xl font-black text-slate-900 dark:text-white md:text-3xl">Admin Paneli — Sade Rehber</h1>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              "Nerede ne yapacağım" tek seferde otursun. Jargon yok.
            </p>
          </header>

          {/* 1. Operasyon vs Analiz */}
          <Card>
            <H2>Önce tek kural: Operasyon mu, Analiz mi?</H2>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              Admin'deki her şey ikiye ayrılır. Kafa karışıklığının tek sebebi bu ayrımı görmemek:
            </p>
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <div className="rounded-xl border border-emerald-200 bg-emerald-50/50 p-4 dark:border-emerald-900/40 dark:bg-emerald-900/10">
                <p className="text-sm font-black text-emerald-700 dark:text-emerald-300">OPERASYON</p>
                <p className="mt-1 text-sm text-slate-700 dark:text-slate-200">
                  Veri girer / düzeltirsin — bir şey <b>yaparsın</b>. Örn: <b>Veri Havuzu</b> (domates fiyatı, ürün özelliği). O yüzden anlaşılır.
                </p>
              </div>
              <div className="rounded-xl border border-sky-200 bg-sky-50/50 p-4 dark:border-sky-900/40 dark:bg-sky-900/10">
                <p className="text-sm font-black text-sky-700 dark:text-sky-300">ANALİZ</p>
                <p className="mt-1 text-sm text-slate-700 dark:text-slate-200">
                  Soru sorarsın, sistem cevap verir — bir şey yapmazsın. Örn: <b>Kontrol Merkezi</b> dashboard'ları. Aklında soru yoksa boş görünmesi normaldir.
                </p>
              </div>
            </div>
          </Card>

          {/* 2. 6 sekme */}
          <Card>
            <H2>Kontrol Merkezi — 6 sekme = 6 farklı soru</H2>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              Her sekmenin sağ üstündeki <b>"Bu Menü Nasıl Çalışır?"</b> balonu o sekmenin sade açıklamasını açar. Tıklayarak sekmeye gidebilirsin:
            </p>
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="text-xs uppercase tracking-wider text-slate-400">
                    <th className="px-3 py-2">Sekme</th>
                    <th className="px-3 py-2">Hangi soruya cevap verir</th>
                    <th className="px-3 py-2">Ne zaman gelirsin</th>
                  </tr>
                </thead>
                <tbody>
                  {TABS.map((t) => (
                    <tr key={t.to} className="border-t border-slate-100 dark:border-slate-800">
                      <td className="px-3 py-2">
                        <Link to={t.to} className="font-bold text-primary hover:underline">{t.name}</Link>
                      </td>
                      <td className="px-3 py-2 text-slate-700 dark:text-slate-200">{t.q}</td>
                      <td className="px-3 py-2 text-slate-500 dark:text-slate-400">{t.when}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 rounded-xl bg-slate-50 p-3 text-sm text-slate-600 dark:bg-slate-800/50 dark:text-slate-300">
              <b>Kısa fark:</b> Segment Analizi = <i>sen sorarsın</i> (en esnek, en zahmetli). Davranış İçgörüleri = <i>sistem hazır cevap getirir</i> (en kolay). Karar Motoru = <i>her şeyin özeti</i>.
            </div>
          </Card>

          {/* 3. Segment 3 adım */}
          <Card>
            <H2>Segment Analizi nasıl kullanılır? (3 adım)</H2>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">Bir <b>Excel pivot tablosu</b> gibi düşün:</p>
            <ol className="mt-4 space-y-3">
              {[
                ['KİMLER?', 'Üstteki segment/chip\'leri seç (Bebekli, Premium, "Tüketti", "SKT yakında"…). Kullanıcıyı süzersin.'],
                ['NE ÖLÇEYİM?', 'Metrik Grupları\'ndan seç (Kullanıcı Sayısı, Kabul Oranı, Alışverişe Dönüşüm…). En fazla 2 metrik — fazlası sonucu karmaşık gösterir.'],
                ['NASIL PARÇALAYAYIM?', 'Kırılım seç (Yemek Tipi, Alerjen Türü, Premium/Free).']
              ].map(([label, body], i) => (
                <li key={i} className="flex gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-white">{i + 1}</span>
                  <p className="pt-0.5 text-sm text-slate-700 dark:text-slate-200">
                    <b>{label}</b> — {body}
                  </p>
                </li>
              ))}
            </ol>
            <div className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-3 text-sm text-slate-700 dark:text-slate-200">
              <b>Örnek:</b> "Bebekli aileler en çok hangi yemeği tüketiyor?" → <b>Bebekli</b> + <b>"Tüketti"</b> + <b>Yemek Tipi</b> kırılımı → çalıştır. Cevap bir tablo.
            </div>
          </Card>

          {/* 4. Veri Havuzu */}
          <Card>
            <H2>Veri Havuzu (operasyon — zaten biliyorsun)</H2>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              Burada veri <b>girer/düzeltirsin</b>: ürün fiyatları, il/ilçe fiyat havuzu, ürün özellikleri, işaretlenen aykırı değerler.
              Dashboard'ların aksine burada <i>aksiyon alırsın</i> — anlamasının kolay olmasının sebebi bu.{' '}
              <Link to="/admin/veri-havuzu" className="font-bold text-primary hover:underline">Veri Havuzu'na git →</Link>
            </p>
          </Card>

          {/* 5. Dürüst not */}
          <Card className="border-amber-200 bg-amber-50/40 dark:border-amber-900/40 dark:bg-amber-900/10">
            <H2>Dürüst not: şu an çoğuna ihtiyacın yok</H2>
            <p className="mt-2 text-sm text-slate-700 dark:text-slate-200">
              Bu analiz araçları <b>binlerce kullanıcın olunca</b> anlam kazanır — "hangi segmente hangi mesaj, hangi özellik tutuyor" diye
              desen ararken. Şu anki seyrek veriyle çoğu ekran zaten boş döner.
            </p>
            <ul className="mt-3 space-y-1 text-sm text-slate-700 dark:text-slate-200">
              <li><b>Bugün düzenli:</b> Veri Havuzu (operasyon).</li>
              <li><b>Ara sıra:</b> Karar Motoru (genel durum), Davranış Ölçümleri (nabız).</li>
              <li><b>Sonra (ölçek gelince):</b> Segment Analizi, Davranış İçgörüleri, Ürün Analizi, Mesaj Şablonları.</li>
            </ul>
            <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
              Yani bugün bu sekmeleri tam anlamaman sana hiçbir şey kaybettirmiyor; bu, "100k kullanıcı" senaryosu için önden kurulmuş altyapı.
            </p>
          </Card>

          {/* 6. Nereye gideyim */}
          <Card>
            <H2>Hızlı "nereye gideyim?" tablosu</H2>
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="text-xs uppercase tracking-wider text-slate-400">
                    <th className="px-3 py-2">İhtiyaç</th>
                    <th className="px-3 py-2">Git</th>
                  </tr>
                </thead>
                <tbody>
                  {GOTO.map((g) => (
                    <tr key={g.need} className="border-t border-slate-100 dark:border-slate-800">
                      <td className="px-3 py-2 text-slate-700 dark:text-slate-200">{g.need}</td>
                      <td className="px-3 py-2">
                        <Link to={g.to} className="font-bold text-primary hover:underline">{g.go}</Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

          </div>
        </div>
      </main>
    </div>
  );
}
